import React, { Component } from 'react';
import { Input, InputNumber, Select, Popconfirm, Button, message } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';

const { Option } = Select;

class EditableCell extends Component {
    state = {
        diseaseList: [],
    }

    componentDidUpdate(prevProps) {
        const { editable: prevEditable, params: { investigationAreaId: prevInvestigationAreaId } } = prevProps;
        const { editable, params: { investigationAreaId }} = this.props;
        if ((!prevEditable && editable) || (prevInvestigationAreaId != investigationAreaId)) {
            this.loadDiseaseList(investigationAreaId);
        }
    }

    loadDiseaseList = () => {
        const { params: { investigationAreaId } } = this.props
        if (investigationAreaId) {
            dictCache.getDict(`DISEASE_AREA_${investigationAreaId}`, cb => {
                $.sendRequest({
                    method: 'POST',
                    url: API_URL.common.queryAllDisease,
                    data: { investigationAreaId },
                    dataType: 'json',
                    doneResult: res => cb(res),
                });
            }, res => {
                this.setState({ diseaseList: res.data });
            });
        } else {
            this.setState({ diseaseList: [] });
        }
    }

    handleInputChange = (e) => {
        this.props.onChange({ diseaseRemark: e.target.value });
    }

    handleSelectChange = (value) => {
        const { diseaseList } = this.state;
        const { type, list } = this.props;
        const params = {};
        switch (type) {
            case 'investigationArea': {
                const { investigationAreaId, investigationAreaName } = list.find(i => i.investigationAreaId == value) || {};
                params.investigationAreaId = investigationAreaId;
                params.investigationAreaName = investigationAreaName;
                params.diseaseId = undefined;
                params.diseaseName = '';
                params.diseaseRemark = '';
                this.loadDiseaseList(investigationAreaId);
                break;
            }
            case 'disease': {
                const { diseaseId, diseaseName } = diseaseList.find(i => i.diseaseId == value) || {};
                params.diseaseId = diseaseId;
                params.diseaseName = diseaseName;
                params.diseaseRemark = '';
                break;
            }
            default:
                params[type] = value;
                break;
        }
        this.props.onChange(params);
    }

 
    getContent = () => {
        const { diseaseList } = this.state;
        const { type, list, params } = this.props;
        const { diseaseId, diseaseName, diseaseRemark, investigationAreaId } = params;
        if (type === 'investigationArea') {
            const Options = list.map(d => <Option key={String(d.investigationAreaId)}>{d.investigationAreaName}</Option>);
            return (
                <Select
                    style={{ width: 100 }}
                    onChange={(value) => this.handleSelectChange(value)}
                    value={investigationAreaId ? String(investigationAreaId) : undefined}
                    placeholder="请选择"
                >
                    {Options}
                </Select>
            )
        } else if (type === 'disease') {
            const options = diseaseList.map(d => <Option key={String(d.diseaseId)}>{d.diseaseName}</Option>);
            return (
                <div>
                    <Select
                        style={{ width: 140 }}
                        disabled={!investigationAreaId}
                        onChange={(value) => this.handleSelectChange(value)}
                        value={diseaseId ? String(diseaseId) : undefined}
                        placeholder="请选择"
                    >
                        {options}
                    </Select>
                    {
                        diseaseName === '其他' &&
                        <Input
                            maxLength="200"
                            placeholder='补充其他说明'
                            style={{ width: 140, marginTop: 4 }}
                            value={diseaseRemark}
                            onChange={e => this.handleInputChange(e)}
                        />
                    }
                </div>
            )
        } else {
            return (
                <InputNumber
                    placeholder='请输入'
                    min={0}
                    precision={0}
                    style={{ width: '100%' }}
                    value={params[type]}
                    disabled={!investigationAreaId || !diseaseId}
                    onChange={value => this.handleSelectChange(value)}
                />
            )
        }
    }

    render () {
        const { editable, value, type, params: { diseaseRemark } } = this.props;
        let result = value;
        if (type === 'disease') {
            result = `${value || ''}${diseaseRemark ? `(${diseaseRemark})` : ''}`;
        }
        return (
            <div>
                {
                    editable ?
                        this.getContent()
                    :
                        result
                }
            </div>
        )
    }
}

class DiseaseTable extends Component {
    state = {
        count: 0,
        loading: false,
        areaList: [],
        dataSource: [],
    }

    componentDidMount() {
        const { dataSource } = this.props;
        const newDataSource = dataSource.map((item, index) => {
            item.key = index;
            return item;
        });
        this.setState({
            count: dataSource.length,
            dataSource: newDataSource,
        }, () => {
            this.loadAreaList();
        });
    }

    componentDidUpdate(prevProps) {
        const { isEdit: prevIsEdit, loading: prevLoading } = prevProps;
        const { isEdit, loading, dataSource = [] } = this.props;
        if ((!prevIsEdit && isEdit) || (prevLoading && !loading)) {
            const newDataSource = dataSource.map((item, index) => {
                item.key = index;
                return item;
            });
            this.setState({
                count: dataSource.length,
                dataSource: newDataSource,
            });
        }
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllInvestigationArea,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ areaList: res.data });
        });
    }

    handleChange = (value, key) => {
        const newData = [...this.state.dataSource];
        const target = newData.find(item => key === item.key);
        if (target) {
            const entries = Object.entries(value || {});
            entries.forEach(entry => {
                target[entry[0]] = entry[1];
            });
            this.setState({ dataSource: newData });
        }
    }

    edit = (key) => {
        const newData = [...this.state.dataSource];
        const target = newData.find(item => key === item.key);
        newData.forEach(i => i.editable = false);
        if (target) {
            target.editable = true;
            this.setState({ dataSource: newData });
        }
    }

    save = (key) => {
        const { reviewDepartmentId, hospitalDepartmentId } = this.props;
        const newData = [...this.state.dataSource];
        const target = newData.find(item => key === item.key);
        if (target) {
            const { investigationAreaId, diseaseId, diseaseName, diseaseRemark, reviewDepartmentOutpatientId } = target;
            if (!investigationAreaId) {
                message.warning('请选择涉及领域');
                return;
            }
            if (!diseaseId) {
                message.warning('请选择涉及疾病');
                return;
            }
            if (diseaseName === '其他' && !diseaseRemark) {
                message.warning('请补充其他说明');
                return;
            }
            const url = reviewDepartmentOutpatientId ? API_URL.hospital.modifyReviewDepartmentOutpatient : API_URL.hospital.addReviewDepartmentOutpatient;
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url,
                data: {
                    reviewDepartmentId,
                    hospitalDepartmentId,
                    ...target,
                },
                dataType: 'json',
                doneResult: res => {
                    const { success, reviewDepartmentId, reviewDepartmentOutpatientId } = res;
                    message.success(success);
                    if (reviewDepartmentOutpatientId) {
                        target.reviewDepartmentOutpatientId = reviewDepartmentOutpatientId;
                    }
                    target.editable = false;
                    this.setState({
                        loading: false,
                        dataSource: newData,
                    }, () => {
                        reviewDepartmentId && this.props.onChange(reviewDepartmentId);
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                }
            };
            $.sendRequest(options);
        }
    }

    cancel = (key) => {
        const newData = [...this.state.dataSource];
        let idx;
        newData.forEach((item, index) => {
            if (item.key == key) {
                if (item.reviewDepartmentOutpatientId) {
                    idx = index
                    this.setState({ loading: true });
                    const options = {
                        method: 'POST',
                        url: API_URL.hospital.deleteReviewDepartmentOutpatient,
                        data: {
                            reviewDepartmentOutpatientId: item.reviewDepartmentOutpatientId,
                        },
                        dataType: 'json',
                        doneResult: res => {
                            message.success(res.success);
                            newData.splice(idx, 1);
                            this.setState({
                                loading: false,
                                dataSource: newData,
                            });
                        },
                        errorResult: () => {
                            this.setState({ loading: false });
                        }
                    };
                    $.sendRequest(options);
                } else {
                    idx = index;
                    if (idx >= 0) {
                        newData.splice(idx, 1);
                        this.setState({ dataSource: newData });
                    }
                }
            }
        });
    }

    getColumns = () => {
        const { areaList } = this.state;
        const { isEdit } = this.props;
        const columns = [{
            title: '涉及领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 120,
            render: (text, record, index) => {
                const { key, editable } = record;
                return (
                    <EditableCell
                        editable={isEdit && editable}
                        value={text}
                        params={record}
                        list={areaList}
                        type='investigationArea'
                        onChange={value => this.handleChange(value, key)}
                    />
                )
            }
        }, {
            title: '涉及疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 160,
            render: (text, record, index) => {
                const { key, editable } = record;
                return (
                    <EditableCell
                        editable={isEdit && editable}
                        value={text}
                        params={record}
                        type='disease'
                        onChange={value => this.handleChange(value, key)}
                    />
                )
            }
        }, {
            title: '月门诊量(人次)',
            dataIndex: 'outpatientNum',
            key: 'outpatientNum',
            width: 130,
            render: (text, record, index) => {
                const { key, editable } = record;
                return (
                    <EditableCell
                        editable={isEdit && editable}
                        value={text}
                        params={record}
                        type='outpatientNum'
                        onChange={value => this.handleChange(value, key)}
                    />
                )
            }
        }, {
            title: '月住院量(人次)',
            dataIndex: 'monthHospitalizedNum',
            key: 'monthHospitalizedNum',
            width: 130,
            render: (text, record, index) => {
                const { key, editable } = record;
                return (
                    <EditableCell
                        editable={isEdit && editable}
                        value={text}
                        params={record}
                        type='monthHospitalizedNum'
                        onChange={value => this.handleChange(value, key)}
                    />
                )
            }
        }, {
            title: '出诊医生数量(人次)',
            dataIndex: 'visitingDoctor',
            key: 'visitingDoctor',
            width: 130,
            render: (text, record, index) => {
                const { key, editable } = record;
                return (
                    <EditableCell
                        editable={isEdit && editable}
                        value={text}
                        params={record}
                        type='visitingDoctor'
                        onChange={value => this.handleChange(value, key)}
                    />
                )
            }
        }];

        if (isEdit) {
            columns.push({
                title: '操作',
                key: 'operation',
                width: 80,
                fixed: 'right',
                render: (text, record, index) => {
                    const { key, editable } = record;
                    return (
                        <span>
                            {
                                editable ?
                                    <a onClick={() => this.save(key)}>保存</a>
                                :
                                    <a onClick={() => this.edit(key)}>修改</a>
                            }
                            <span className="ant-divider" />
                            <Popconfirm title="确定要删除该行数据?" onConfirm={() => this.cancel(key)}>
                                <a>删除</a>
                            </Popconfirm>
                        </span>
                    )
                },
            });
        }
        return columns;
    }

    handleAdd = () => {
        const { count, dataSource } = this.state;
        const newData = {
          key: count,
          editable: true,
        };
        dataSource.forEach(i => i.editable = false);
        this.setState({
          dataSource: [...dataSource, newData],
          count: count + 1,
        });
    }

    render() {
        const { loading, dataSource } = this.state;
        const { isEdit } = this.props;
        return (
            <div style={{ marginBottom: 10 }}>
                { isEdit && <Button onClick={this.handleAdd} style={{ marginBottom: 10 }}>添加行</Button> }
                <TableC
                    loading={loading}
                    scrollY={280}
                    columns={this.getColumns()}
                    className="diseaseTable"
                    data={dataSource}
                />
            </div>
        )
    }
}

export default DiseaseTable;


// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/DiseaseTable.js